import {call, put, takeLatest, delay} from 'redux-saga/effects'
import {actions} from './action'
import {actionTypes} from './constants'
import {ResponseModel} from 'src/cms/helpers/Models/ResponseModel'
import {service} from './service'
import {ActionModel} from 'src/cms/helpers/Models/ActionModel'
import {globalActionTypes} from 'src/app/modules/errors/redux/constants'
import {ParamsModel} from 'src/app/modules/common/Model'

function* getCreditEligibilityReportSaga(action: ActionModel) {
  try {
    const params: ParamsModel = action.payload
    yield delay(300)
    const response: ResponseModel = yield call(service.getCreditEligibilityReport, params)
    yield put(actions.getCreditEligibilityReportSuccess(response?.data?.data))
    yield put(actions.getCreditEligibilityReportFinish())
  } catch (err: any) {
    if (err.response) {
      yield put({type: globalActionTypes.GLOBAL_ERROR, payload: err.response.data.message})
    }
    yield put(actions.getCreditEligibilityReportFinish())
  }
}

export function* saga() {
  yield takeLatest(actionTypes.GET_CREDIT_ELIGIBILITY_REPORT_START, getCreditEligibilityReportSaga)
}
